import React from 'react';
import { Box, Button, DataTable } from '../../../../common/components';
import { applyFilter } from '../../../../common/components/DataTable/redux/dataTableActions';
import { TableHeaderColumn } from 'react-bootstrap-table';
import { Col, ControlLabel, FormControl, Row } from 'react-bootstrap';
import { push } from 'react-router-redux';
import { InternalButtonBar } from '../../../layout/components';
import formatDateTime from '../../../../helpers/formatDateTime';
import { connect } from 'react-redux';

const ContentAnnouncementList = ({ goTo, onApplyFilter }) => {
  const handleRowClick = (row) => {
    goTo('/admin/content/' + row.id);
  };

  const handleSearchUpdate = (event) => {
    onApplyFilter('announcements', 'filter[name]', event.target.value);
  };

  return (
    <div>
      <Box>
        <Row>
          <Col xs={5}>
            <ControlLabel>Search</ControlLabel>
            <FormControl onChange={handleSearchUpdate} />
          </Col>
        </Row>
      </Box>
      <Box>
        <DataTable
          source="/contents"
          name="announcements"
          autoFilters={[{ type: 'filter[template.type]', value: 'announcement' }]}
          showTotal
          onRowSelect={handleRowClick}
        >
          <TableHeaderColumn dataField="id" isKey hidden />

          <TableHeaderColumn dataField="name" dataSort>
            Name
          </TableHeaderColumn>

          <TableHeaderColumn
            dataField="from_date"
            dataSort
            dataFormat={formatDateTime}
            width={'180px'}
          >
            From Date
          </TableHeaderColumn>

          <TableHeaderColumn
            dataField="to_date"
            dataSort
            dataFormat={formatDateTime}
            width={'180px'}
          >
            To Date
          </TableHeaderColumn>
        </DataTable>

        <Row>
          <Col sm={12}>
            <InternalButtonBar
              buttons={[
                {
                  permissions: ['content_management.create'],
                  button: (
                    <Button
                      link
                      to="/admin/content/new?template=announcement"
                      className="pull-right"
                      bsStyle="primary"
                      label="New Announcement"
                    />
                  ),
                },
              ]}
            />
          </Col>
        </Row>
      </Box>
    </div>
  );
};
export default connect(
  null,
  {
    onApplyFilter: applyFilter,
    goTo: push,
  },
)(ContentAnnouncementList);
